import React, { useEffect, useState } from 'react'
import System from 'src/helper/system';
import { useCartStore } from 'src/hooks/cart';
import { profileStore } from 'src/hooks/profile';
import useReduxState from 'src/hooks/useReduxState';
import Constants from 'src/helper/Constants';
import Helper from 'src/helper/Helper';

const CheckoutInvoiceAddress = (props) => {
    const { orderValidation, setOrderValidation, setShowAlert } = props
    const { siteUser: { WEB, CORE }, addressType, speedBoats: { japanAbbr, apacAbbr } } = Constants
    const { translation: t } = System;

    const [{ CART_PRODUCTS, CART_DATA }, { }, { }] = useCartStore();
    const [{ profile_account_information }, { }] = profileStore();

    const [addressData, setAddressData] = useState({ billToData: null, shipToData: null })

    const [checkoutInfo, setCheckoutInfo] = useReduxState({}, 'setCheckoutInfo')
    const shippingAddressInfo = checkoutInfo.shippingAddressInfo || {}
    const paymentMethodInfo = checkoutInfo.paymentMethodInfo || {}

    const isOnlySoftwareParts = CART_PRODUCTS && !Object.values(CART_PRODUCTS).some(f => f.SoftwareDownloadFlag === false);
    const isWebUser = System.avUserInfoData.currentUser === WEB
    const isCoreUser = System.avUserInfoData.currentUser === CORE
    const coreUserAddress = profile_account_information?.billTo?.find(ele => profile_account_information?.customerNo === ele?.id)

    useEffect(() => {
        setAddressData({
            billToData: profile_account_information?.billTo?.length ? (isCoreUser && coreUserAddress?.address?.addressType === Constants.PRIMARY && coreUserAddress) ? { ...coreUserAddress.address } : profile_account_information?.billTo[0]?.address : null,
            shipToData: shippingAddressInfo?.address
        })
    }, [profile_account_information?.billTo, shippingAddressInfo?.address])

    useEffect(() => {
        setCheckoutInfo({
            ...checkoutInfo, paymentMethodInfo: {
                ...paymentMethodInfo,
                invoiceAddressType: isOnlySoftwareParts ?
                    (profile_account_information?.billTo?.length != 0 ? addressType.BILL_TO : paymentMethodInfo?.invoiceAddressType) :
                    paymentMethodInfo?.invoiceAddressType
            }
        })
    }, [CART_DATA, profile_account_information?.billTo])

    const openInvoicePopup = (addressInfo) => {
        System.popup('ProfileAddressPopup', addressInfo);
    }

    return (
        <div className='invoice-address-container'>
            <div className='bs5 row'>
                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 invoice-address-list'>
                    <h3 className="mt-0 mb-2">{t('invoiceAddress')}:</h3>
                    {isOnlySoftwareParts ?
                        <>
                            <div className='choose-address-box'>
                                {profile_account_information?.billTo?.length <= 0 ?
                                    <button type="button" onClick={() => openInvoicePopup({ 'type': addressType.BILL_TO, 'addressInfo': {} })} className="addnewaddress text-uppercase mt-2">
                                        <i className="fa fa-plus me-2" aria-hidden="true"></i>{t('addAnInvoiceAddress')}
                                    </button>
                                    : <div>
                                        <p className='mt-0 mb-2'><b>{t('currentInvoiceAddress')}</b></p>
                                        <div className='font-arial font-13'>
                                            {addressData.billToData && profile_account_information?.billTo?.[0]?.companyName}
                                            <div className='font-arial font-13'>
                                                {addressData.billToData?.addressLineOne}, {Helper.valueIsNotNull(addressData.billToData?.addressLineTwo) ?
                                                    (<><br />{addressData.billToData?.addressLineTwo + ","}</>) : ""}<br /> {addressData.billToData?.cityName},
                                                {Helper.valueIsNotNull(addressData.billToData?.stateName) ? addressData.billToData?.stateName + "," : ""}
                                                {addressData.billToData?.postalCode},<br />{addressData.billToData?.countryName}</div>
                                        </div>
                                    </div>}

                            </div>
                        </> :
                        <>
                            {isWebUser ? <p className='mt-0 mb-2'>{t('whereDoYouWantYourInvoiceSent')}</p> : <p className='mt-0 mb-2'><b>{t('currentInvoiceAddress')}</b></p>}

                            {addressData.billToData &&
                                <>
                                    {isWebUser && <div className="form-check mb-1">
                                        <input className="form-check-input mt-1" type="radio" name="invoiceAddress" id="radio1"
                                            value="currentInvoice"
                                            onChange={({ target: { value } }) => {
                                                setShowAlert(false);
                                                setCheckoutInfo({ ...checkoutInfo, paymentMethodInfo: { ...paymentMethodInfo, invoiceAddressType: addressType.BILL_TO } })
                                            }} />
                                        <label className="form-check-label" htmlFor="radio1">{t('currentInvoiceAddress')}</label>
                                    </div>}

                                    <div className='choose-address-box'>
                                        <div className='font-arial font-13 text-wrap text-break'>
                                            {addressData.billToData && (isCoreUser ? coreUserAddress?.companyName : profile_account_information?.billTo?.[0]?.companyName)}
                                            {System.getCurrentRegionWithType(Constants.speedBoats.japanAbbr) ? <div className='font-arial font-13'>
                                                {addressData.billToData?.addressLineOne}, {Helper.valueIsNotNull(addressData.billToData?.addressLineTwo) ?
                                                    (<><br />{addressData.billToData?.addressLineTwo + ","}</>) : ""}<br /> {addressData.billToData?.cityName},
                                                {Helper.valueIsNotNull(addressData.billToData?.stateName) ? addressData.billToData?.stateName + "," : ""}
                                                {addressData.billToData?.postalCode},<br />{addressData.billToData?.countryName}
                                            </div>
                                                :
                                                <div className='font-arial font-13 text-wrap text-break'>
                                                    {Helper.valueIsNotNull(addressData.billToData?.houseNum) ? (<><br />{addressData.billToData?.houseNum + ", "} </>) : ""}
                                                    {addressData.billToData?.addressLineOne},
                                                    {Helper.valueIsNotNull(addressData.billToData?.houseNumSuppl) ? (<>{addressData.billToData?.houseNumSuppl + ","}</>) : ""}
                                                    {Helper.valueIsNotNull(addressData.billToData?.addressLineTwo) ? (<><br />{addressData.billToData?.addressLineTwo + ","}</>) : ""}
                                                    {Helper.valueIsNotNull(addressData.billToData?.addressLineThree) ? (<><br />{addressData.billToData?.addressLineThree + ","}</>) : ""}<br />
                                                    {addressData.billToData?.cityName},
                                                    {Helper.valueIsNotNull(addressData.billToData?.district) ? addressData.billToData?.district + "," : ""}
                                                    {Helper.valueIsNotNull(addressData.billToData?.stateName) ? addressData.billToData?.stateName + "," : ""}
                                                    {addressData.billToData?.postalCode},<br />
                                                    {addressData.billToData?.countryName}
                                                </div>
                                            }
                                        </div>

                                    </div>

                                    {isWebUser && <p className="font-arial font-13 text-blue cursor-pointer"
                                        onClick={() => openInvoicePopup({ 'type': addressType.BILL_TO, 'addressInfo': addressData.billToData && profile_account_information?.billTo[0] })}>
                                        {t('edit')}
                                    </p>}
                                </>
                            }

                            {isWebUser &&
                                <>
                                    <div className="form-check mb-1">
                                        <input className="form-check-input mt-1" type="radio" name="invoiceAddress" id="radio2"
                                            value="defaultShipping"
                                            onChange={({ target: { value } }) => {
                                                setShowAlert(false);
                                                setCheckoutInfo({ ...checkoutInfo, paymentMethodInfo: { ...paymentMethodInfo, invoiceAddressType: addressType.SHIP_TO } })
                                            }} />
                                        <label className="form-check-label" htmlFor="radio2">{t('useShippingAddressAsInvoiceAddress')}</label>
                                    </div>

                                    {(!paymentMethodInfo?.invoiceAddressType && profile_account_information?.billTo?.length <= 0) ? <></> : addressData.shipToData && <div className='choose-address-box'>
                                        <div className='font-arial font-13'>
                                            {shippingAddressInfo?.companyName}
                                            {System.getCurrentRegionWithType(Constants.speedBoats.japanAbbr) ?
                                                <p className='font-arial font-13 text-wrap text-break'>
                                                    {addressData.shipToData?.addressLineOne}, {Helper.valueIsNotNull(addressData.shipToData?.addressLineTwo) ?
                                                        (<><br />{addressData.shipToData?.addressLineTwo + ","}</>) : ""}<br /> {addressData.shipToData?.cityName},
                                                    {Helper.valueIsNotNull(addressData.shipToData?.stateName) ? addressData.shipToData?.stateName + "," : ""}
                                                    {addressData.shipToData?.postalCode},<br /> {addressData.shipToData?.countryName}</p>
                                                :
                                                <p className='font-arial font-13 text-wrap text-break'>
                                                    {Helper.valueIsNotNull(addressData.shipToData?.houseNum) ? (<>{addressData.shipToData?.houseNum + ", "} </>) : ""}
                                                    {addressData.shipToData?.addressLineOne}, {Helper.valueIsNotNull(addressData.shipToData?.houseNumSuppl) ? (<> {addressData.shipToData?.houseNumSuppl + ","}</>) : ""} {Helper.valueIsNotNull(addressData.shipToData?.addressLineTwo) ? (<><br />{addressData.shipToData?.addressLineTwo + ","}</>) : ""}
                                                    {Helper.valueIsNotNull(addressData.shipToData?.addressLineThree) ? (<><br />{addressData.shipToData?.addressLineThree + ","}</>) : ""}<br />
                                                    {addressData.shipToData?.cityName},
                                                    {Helper.valueIsNotNull(addressData.shipToData?.district) ? addressData.shipToData?.district + "," : ""}
                                                    {Helper.valueIsNotNull(addressData.shipToData?.stateName) ? addressData.shipToData?.stateName + "," : ""}
                                                    {addressData.shipToData?.postalCode},<br />
                                                    {addressData.shipToData?.countryName}
                                                </p>
                                            }
                                        </div>
                                    </div>}

                                    {profile_account_information?.billTo?.length <= 0 &&
                                        <button type="button" onClick={() => openInvoicePopup({ 'type': addressType.BILL_TO, 'addressInfo': {} })} className="addnewaddress text-uppercase mt-2">
                                            <i className="fa fa-plus me-2" aria-hidden="true"></i>{t('addAnInvoiceAddress')}
                                        </button>}
                                </>}
                        </>}
                </div>
                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 '>
                    <div className='form-group'>
                        <label className="form-label">{t('purchaseOrderNumber')} ({System.getCurrentRegionWithType(japanAbbr) || System.getCurrentRegionWithType(apacAbbr, WEB) ? t('optional') : t('mandatory')})</label>
                        <input type="text"
                            className={`form-control form-control-sm ${orderValidation?.purchaseOrderNumber ? "error" : ""}`}
                            placeholder={t('purchaseOrderNumber')} name="purchaseOrderNumber"
                            maxLength={35}
                            onChange={({ target: { value } }) => {
                                setOrderValidation({})
                                setCheckoutInfo({ ...checkoutInfo, paymentMethodInfo: { ...paymentMethodInfo, purchaseOrderNumber: value } })
                            }} />
                        {orderValidation?.purchaseOrderNumber && <p className="error">{orderValidation?.purchaseOrderNumber}</p>}
                    </div>
                </div>
            </div>
            <hr className='p-0'></hr>
        </div>
    );
}

export default CheckoutInvoiceAddress;